module.exports = {"361022100":"日峰镇","361022101":"宏村镇","361022102":"洵口镇","361022103":"熊村镇","361022104":"龙安镇","361022105":"德胜镇","361022106":"华山镇","361022200":"潭溪乡","361022201":"湖坊乡","361022202":"荷源乡","361022203":"厚村乡","361022204":"社苹乡","361022205":"樟溪乡","361022206":"西城乡","361022207":"中田乡","361022401":"黎川县工业园区管理委员会","361022500":"德胜企业集团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361022.json
// module id = 1229
// module chunks = 0